import type { TFunction } from "i18next";
import { z } from "zod";

export const MAX_APPROVE_DEFICIENCY_COMMENTS_LENGTH = 1000;

export const approveDeficiencySchema = (t: TFunction) =>
  z.object({
    comments: z
      .string()
      .trim()
      .max(
        MAX_APPROVE_DEFICIENCY_COMMENTS_LENGTH,
        t("form-validation.max-length", {
          label: t("deficiencies.decision-drawer.comments"),
          max: MAX_APPROVE_DEFICIENCY_COMMENTS_LENGTH,
        }),
      ),
  });

export type ApproveDeficiencyFormData = z.infer<ReturnType<typeof approveDeficiencySchema>>;
